module.exports = __webpack_public_path__ + "img/banner.4b21dfa8.png";